import MedicationCard from './review/MedicationCard';
import { useLanguage } from '../contexts/LanguageContext';
import {
  formatDoseLabel,
  resolveDeviationReasonText,
  splitMedicationsByGiven,
} from '../utils/medicationDeviation';

function DeviationRow({ med, t }) {
  const name = med.drug_name || med.name || '—';
  const dose = formatDoseLabel(med);
  const time = med.scheduled_time || med.time_given || '—';
  const reason = resolveDeviationReasonText(t, med);

  return (
    <div className="rounded-xl border border-[#FECACA] bg-[#FEF2F2] p-3">
      <p className="text-[15px] font-semibold text-[#991B1B]">
        ✗ {name}
        {dose ? ` ${dose}` : ''}
        {med.route ? ` ${med.route}` : ''}
        {time && time !== '—' ? ` — ${time}` : ''}
      </p>
      {reason ? (
        <p className="mt-1 text-xs font-medium text-[#B91C1C]">
          {t('notGivenWithReason', { reason })}
        </p>
      ) : (
        <p className="mt-1 text-xs font-medium text-[#B91C1C]">{t('notGiven')}</p>
      )}
    </div>
  );
}

export default function MedicationAdminNote({ note, onChange, allowDelete = true }) {
  const { t } = useLanguage();
  const { given, notGiven } = splitMedicationsByGiven(note);

  const setMeds = (medications_administered) => {
    onChange({
      ...note,
      medications_administered,
      medications: medications_administered,
      unverified_medications: medications_administered.filter((m) => m.confidence === 'low'),
    });
  };

  const updateGivenMed = (index, updated) => {
    const nextGiven = [...given];
    nextGiven[index] = updated;
    setMeds([...nextGiven, ...notGiven]);
  };

  const deleteGivenMed = (index) => {
    const nextGiven = given.filter((_, i) => i !== index);
    setMeds([...nextGiven, ...notGiven]);
  };

  if (!given.length && !notGiven.length) {
    return <p className="text-sm text-gray-500">No medications recorded.</p>;
  }

  return (
    <div className="flex flex-col gap-2.5">
      {given.map((med, i) => (
        <MedicationCard
          key={`given-${i}`}
          med={med}
          flags={note.flags || []}
          onChange={(updated) => updateGivenMed(i, updated)}
          onDelete={() => deleteGivenMed(i)}
          allowDelete={allowDelete}
        />
      ))}

      {notGiven.length > 0 ? (
        <div className="mt-1 space-y-2">
          <h4 className="text-xs font-bold uppercase tracking-wide text-[#B91C1C]">
            {t('medicationDeviations')}
          </h4>
          {notGiven.map((med, i) => (
            <DeviationRow key={`dev-${i}`} med={med} t={t} />
          ))}
        </div>
      ) : null}
    </div>
  );
}
